<template>
  <div
    class="w100p"
    @mouseover="onMouseover"
    @mouseleave="onMouseout"
    style="position:relative"
  >
    <transition name="fade">
      <v-icon
        v-if="isMouseover"
        style="position:absolute;right:0px;top:0px"
        small
        class="clickable"
        @click="goEdit"
        >mdi-square-edit-outline</v-icon
      >
    </transition>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMouseover: false
    };
  },
  methods: {
    onMouseover() {
      this.isMouseover = true;
    },
    onMouseout() {
      this.isMouseover = false;
    },
    goEdit() {
      this.$emit("edit");
    }
  }
};
</script>

<style coped></style>
